import React, { useState } from "react";
import { Form, Typography, Input, DatePicker, Select } from "antd";
import inputStyles from "../../../../../styles/Custom/Input.module.css";
import PressureSoreTable from "./PressureSoreModal";
import { hospitalKeys, prophylaxisKeys } from "../../formsKeys";
import useReceptionistMobilePickerProps from "../../../../Receptionist/receptionistMobilePickerProps";

const ClinicalProgress = ({ setPressureSorePoints, pressureSorePoints }) => {
  const [showOtherInput, setShowOtherInput] = useState(false);
  const mobilePickerProps = useReceptionistMobilePickerProps();

  // Handle DVT Prophylaxis Change
  const handleDvtChange = (value) => {
    setShowOtherInput(value === "Others");
  };

  return (
    <>
      <Typography>
        <Typography.Text>
          Over the course of stay with the center, He/she was undergoing regular
          physiotherapy, other supportive and symptomatic therapy. He/she remained
          cardio vascularly stable. Tracheostomy Care and Respiratory Support
          was continued. As the patient condition improved Tracheostomy was
          successfully decannulated on{" "}
        </Typography.Text>
        <Form.Item
          style={{ display: "inline-block" }}
          name={["clinical_progress", "date"]}
        >
          <DatePicker
            className={inputStyles.mdDatePicker}
            style={{ width: "150px" }}
            inputReadOnly
            {...mobilePickerProps}
          />
        </Form.Item>
      </Typography>

      <Typography>
        <Typography.Text>He/She received</Typography.Text>
        <Form.Item
          style={{ display: "inline-block" }}
          name={["clinical_progress", "dvt_prophylaxis"]}
        >
          <Select
            options={prophylaxisKeys}
            className={inputStyles.mdInput}
            style={{ width: "250px" }}
            placeholder="DVT Prophylaxis"
            onChange={handleDvtChange} // Handle Change
          />
        </Form.Item>

        {showOtherInput && (
          <Form.Item
            style={{ display: "inline-block", marginLeft: "10px" }}
            name={["clinical_progress", "other_dvt_prophylaxis"]}
          >
            <Input
              placeholder="Enter Other Prophylaxis"
              className={inputStyles.mdInput}
              style={{ width: "250px" }}
            />
          </Form.Item>
        )}

        <Typography.Text>as DVT Prophylaxis</Typography.Text>
      </Typography>

      <Typography>
        <Typography.Text>
          He/She received regular wound care, with frequent change of positioning
          with medical support for the following Pressure Sores
        </Typography.Text>
        <PressureSoreTable
          setPressureSorePoints={setPressureSorePoints}
          pressureSorePoints={pressureSorePoints}
        />
        <br />
        <Typography>
          <Typography.Text>However He,She </Typography.Text>
          <Form.Item
            style={{ display: "inline-block" }}
            name={["clinical_progress", "underwent"]}
          >
            <Input className={inputStyles.mdInput} />
          </Form.Item>
          <Typography.Text>
            {" "}
            and thus is being sent for further management at your hospital{" "}
          </Typography.Text>
          <Form.Item
            style={{ display: "inline-block" }}
            name={["clinical_progress", "at_hospital"]}
          >
            <Select
              options={hospitalKeys}
              className={inputStyles.mdInput}
              style={{ width: "250px" }}
            />
          </Form.Item>
        </Typography>
      </Typography>
    </>
  );
};

export default ClinicalProgress;
